import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ pagination, currentPage, onPageChange }) => {
  if (!pagination || !pagination.links) {
    return null;
  }

  const hasPrevious = pagination.prevPageUrl !== null;
  const hasNext = pagination.nextPageUrl !== null;

  return (
    <div className="flex items-center justify-center gap-2 mt-6">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!hasPrevious}
        className="p-2 rounded-lg border border-gray-300 text-prose-brand hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200"
        aria-label="Previous page"
      >
        <ChevronLeft size={20} />
      </button>

      <div className="flex gap-1">
        {pagination.links
          ?.filter((link) => !link.label.includes('&laquo;') && !link.label.includes('&raquo;'))
          .map((link, index) => {
            const pageNum = parseInt(link.label);
            const isActive = link.active;

            if (isNaN(pageNum)) {
              return null;
            }

            return (
              <button
                key={index}
                onClick={() => onPageChange(pageNum)}
                className={`px-2 sm:px-3 py-2 rounded-lg border transition duration-200 text-xs sm:text-sm ${
                  isActive
                    ? 'bg-prose-brand text-white border-prose-brand'
                    : 'border-gray-300 text-prose-brand hover:bg-gray-100'
                }`}
              >
                {pageNum}
              </button>
            );
          })}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!hasNext}
        className="p-2 rounded-lg border border-gray-300 text-prose-brand hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200"
        aria-label="Next page"
      >
        <ChevronRight size={20} />
      </button>

      {pagination.total > 0 && (
        <div className="ml-4 text-xs sm:text-sm text-prose-black/60">
          Showing {pagination.from} - {pagination.to} of {pagination.total}
        </div>
      )}
    </div>
  );
};

export default Pagination;
